<ion-header>
  <ion-toolbar>
    <ion-title>Cookie Policy</ion-title>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <h3>What Are Cookies?</h3>
  <p>Cookies are small text files that are stored on your device when you visit a website. They help the website function properly and improve your browsing experience.</p>

  <h3>Types of Cookies We Use</h3>

    <ul>
      <li>Essential Cookies: These cookies are necessary for the website to function and cannot be switched off in our systems.</li>
      <li>Performance Cookies: These cookies collect information about how visitors use our website, allowing us to improve its performance.</li>
      <li>Functional Cookies: These cookies remember choices you make to enhance your experience on our website.</li>
    </ul>


  <h3>Purpose of Cookies</h3>

  We use cookies to:

  <ul>
    <li>Ensure the website functions correctly.</li>
    <li>Improve user experience by remembering your preferences.</li>
    <li>Collect anonymous statistical data on website usage.</li>
    <li>Provide personalized content and advertising.</li>
  </ul>

  <h3>Third-Party Cookies</h3>

  <p>
    We may use third-party services that use cookies to collect information on our behalf. These third-party cookies are used for analytical and advertising purposes.
  </p>

  <ul>
    <li>Google Analytics:This cookie is associated with Google Universal Analytics and is used to distinguish unique users by assigning a randomly generated number as a client identifier. It is included in each page request in a site and used to calculate visitor, session, and campaign data for the site's analytics reports. By default, it is set to expire after 2 years, although this is customizable by website owners.</li>
    <li>AWS Classic Elastic Load Balancer Cookie: This AWS cookie is used to map the session to the instance and enables "sticky sessions". AWSELB is assigned if your application manages its own session. The lifetime of the special Elastic Load Balancing cookie, AWSELB, follows the lifetime of the application-generated cookie specified in the policy configuration. The AWS load balancer only inserts this new stickiness cookie when the application response includes a new application cookie.</li>
  </ul>

  <h3>
    Managing Cookies
  </h3>

  <p>
    You can manage your cookie preferences through your browser settings. Here are some resources on how to do this:
  </p>

  <ul>
    <li><a href="https://allaboutcookies.org/how-to-clear-cookies-chrome">Google Chrome</a></li>
    <li><a href="https://allaboutcookies.org/how-to-clear-cookies-safari">Safari</a></li>
    <li><a href="https://allaboutcookies.org/how-to-clear-cookies-microsoft-edge">Microsoft Edge</a></li>
    <li><a href="https://allaboutcookies.org/how-to-clear-cookies-firefox">Mozilla Firefox</a></li>
    <li><a href="https://allaboutcookies.org/how-to-clear-cookies-opera">Opera</a></li>
  </ul>

  <h3>Contact Us</h3>

  <h3>Data Protection</h3>
  <p>We are committed to protecting your data and ensuring compliance with applicable privacy regulations, such as GDPR and CCPA.</p>


  <p>
    If you have any questions about our use of cookies, please contact us at admin&#64;ioncourt.com.
  </p>

  <h3>Updates to This Policy</h3>
  <p>We may update this cookie policy from time to time. We will notify you of any significant changes by updating the date at the top of this page.</p>

</ion-content>